// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/form_submission.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { FloatValue, Message, proto3, UInt32Value } from "@bufbuild/protobuf";
import { FormSubmissionWorkflowState } from "./form_submission_workflow_state_pb.ts";
import { QuickForm } from "./quick_form_pb.ts";
import { Patient } from "../patient_pb.ts";
import { User } from "../user_pb.ts";
import { UploadLog } from "../upload_log_pb.ts";

/**
 * @generated from message qliq_protobuf.chat.FormSubmission
 */
export class FormSubmission extends Message<FormSubmission> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: uint32 chat_user_id = 2;
   */
  chatUserId = 0;

  /**
   * @generated from field: uint32 group_id = 3;
   */
  groupId = 0;

  /**
   * @generated from field: uint32 quick_form_id = 4;
   */
  quickFormId = 0;

  /**
   * @generated from field: uint32 conversation_id = 5;
   */
  conversationId = 0;

  /**
   * @generated from field: qliq_protobuf.chat.FormSubmissionWorkflowState workflow_state = 6;
   */
  workflowState = FormSubmissionWorkflowState.FORM_SUBMISSION_WORKFLOW_STATE_UNKNOWN;

  /**
   * @generated from field: qliq_protobuf.chat.FormSubmission.Submission submission = 7;
   */
  submission?: FormSubmission_Submission;

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm form = 8;
   */
  form?: QuickForm;

  /**
   * @generated from field: string source = 9;
   */
  source = "";

  /**
   * @generated from field: string uuid = 10;
   */
  uuid = "";

  /**
   * @generated from field: string iv = 11;
   */
  iv = "";

  /**
   * @generated from field: qliq_protobuf.Patient patient = 12;
   */
  patient?: Patient;

  /**
   * @generated from field: string opened_at = 13;
   */
  openedAt = "";

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt = "";

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt = "";

  /**
   * @generated from field: qliq_protobuf.User user = 17;
   */
  user?: User;

  /**
   * @generated from field: repeated qliq_protobuf.UploadLog upload_logs = 18;
   */
  uploadLogs: UploadLog[] = [];

  /**
   * @generated from field: string uploaded_at = 19;
   */
  uploadedAt = "";

  /**
   * @generated from field: string submitted_at = 20;
   */
  submittedAt = "";

  /**
   * @generated from field: bool is_legacy_submission = 21;
   */
  isLegacySubmission = false;

  constructor(data?: PartialMessage<FormSubmission>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "chat_user_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "group_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "quick_form_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "conversation_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "workflow_state", kind: "enum", T: proto3.getEnumType(FormSubmissionWorkflowState) },
    { no: 7, name: "submission", kind: "message", T: FormSubmission_Submission },
    { no: 8, name: "form", kind: "message", T: QuickForm },
    { no: 9, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "iv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "patient", kind: "message", T: Patient },
    { no: 13, name: "opened_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "user", kind: "message", T: User },
    { no: 18, name: "upload_logs", kind: "message", T: UploadLog, repeated: true },
    { no: 19, name: "uploaded_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "submitted_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "is_legacy_submission", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission {
    return new FormSubmission().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission {
    return new FormSubmission().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission {
    return new FormSubmission().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission | PlainMessage<FormSubmission> | undefined, b: FormSubmission | PlainMessage<FormSubmission> | undefined): boolean {
    return proto3.util.equals(FormSubmission, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.chat.FormSubmission.WeightUnit
 */
export enum FormSubmission_WeightUnit {
  /**
   * @generated from enum value: WEIGNT_UNIT_UNKNOWN = 0;
   */
  WEIGNT_UNIT_UNKNOWN = 0,

  /**
   * @generated from enum value: LBS = 1;
   */
  LBS = 1,

  /**
   * @generated from enum value: KG = 2;
   */
  KG = 2,

  /**
   * @generated from enum value: G = 3;
   */
  G = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(FormSubmission_WeightUnit)
proto3.util.setEnumType(FormSubmission_WeightUnit, "qliq_protobuf.chat.FormSubmission.WeightUnit", [
  { no: 0, name: "WEIGNT_UNIT_UNKNOWN" },
  { no: 1, name: "LBS" },
  { no: 2, name: "KG" },
  { no: 3, name: "G" },
]);

/**
 * @generated from enum qliq_protobuf.chat.FormSubmission.TimeUnit
 */
export enum FormSubmission_TimeUnit {
  /**
   * @generated from enum value: TIME_UNIT_UNKNOWN = 0;
   */
  TIME_UNIT_UNKNOWN = 0,

  /**
   * @generated from enum value: HOUR = 1;
   */
  HOUR = 1,

  /**
   * @generated from enum value: DAY = 2;
   */
  DAY = 2,

  /**
   * @generated from enum value: WEEK = 3;
   */
  WEEK = 3,

  /**
   * @generated from enum value: MONTH = 4;
   */
  MONTH = 4,

  /**
   * @generated from enum value: YEAR = 5;
   */
  YEAR = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(FormSubmission_TimeUnit)
proto3.util.setEnumType(FormSubmission_TimeUnit, "qliq_protobuf.chat.FormSubmission.TimeUnit", [
  { no: 0, name: "TIME_UNIT_UNKNOWN" },
  { no: 1, name: "HOUR" },
  { no: 2, name: "DAY" },
  { no: 3, name: "WEEK" },
  { no: 4, name: "MONTH" },
  { no: 5, name: "YEAR" },
]);

/**
 * @generated from enum qliq_protobuf.chat.FormSubmission.DosageUnit
 */
export enum FormSubmission_DosageUnit {
  /**
   * @generated from enum value: DOSAGE_UNIT_UNKNOWN = 0;
   */
  DOSAGE_UNIT_UNKNOWN = 0,

  /**
   * @generated from enum value: ML = 1;
   */
  ML = 1,

  /**
   * @generated from enum value: MG = 2;
   */
  MG = 2,

  /**
   * @generated from enum value: OTHER = 3;
   */
  OTHER = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(FormSubmission_DosageUnit)
proto3.util.setEnumType(FormSubmission_DosageUnit, "qliq_protobuf.chat.FormSubmission.DosageUnit", [
  { no: 0, name: "DOSAGE_UNIT_UNKNOWN" },
  { no: 1, name: "ML" },
  { no: 2, name: "MG" },
  { no: 3, name: "OTHER" },
]);

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Address
 */
export class FormSubmission_Address extends Message<FormSubmission_Address> {
  /**
   * @generated from field: string address = 1;
   */
  address = "";

  /**
   * @generated from field: string zip = 2;
   */
  zip = "";

  /**
   * @generated from field: string city = 3;
   */
  city = "";

  /**
   * @generated from field: string state = 4;
   */
  state = "";

  constructor(data?: PartialMessage<FormSubmission_Address>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Address";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Address {
    return new FormSubmission_Address().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Address {
    return new FormSubmission_Address().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Address {
    return new FormSubmission_Address().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Address | PlainMessage<FormSubmission_Address> | undefined, b: FormSubmission_Address | PlainMessage<FormSubmission_Address> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Address, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.BloodPressure
 */
export class FormSubmission_BloodPressure extends Message<FormSubmission_BloodPressure> {
  /**
   * @generated from field: google.protobuf.UInt32Value systolic = 1;
   */
  systolic?: number;

  /**
   * @generated from field: google.protobuf.UInt32Value diastolic = 2;
   */
  diastolic?: number;

  constructor(data?: PartialMessage<FormSubmission_BloodPressure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.BloodPressure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "systolic", kind: "message", T: UInt32Value },
    { no: 2, name: "diastolic", kind: "message", T: UInt32Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_BloodPressure {
    return new FormSubmission_BloodPressure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_BloodPressure {
    return new FormSubmission_BloodPressure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_BloodPressure {
    return new FormSubmission_BloodPressure().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_BloodPressure | PlainMessage<FormSubmission_BloodPressure> | undefined, b: FormSubmission_BloodPressure | PlainMessage<FormSubmission_BloodPressure> | undefined): boolean {
    return proto3.util.equals(FormSubmission_BloodPressure, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Boolean
 */
export class FormSubmission_Boolean extends Message<FormSubmission_Boolean> {
  /**
   * @generated from field: bool value = 1;
   */
  value = false;

  constructor(data?: PartialMessage<FormSubmission_Boolean>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Boolean";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Boolean {
    return new FormSubmission_Boolean().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Boolean {
    return new FormSubmission_Boolean().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Boolean {
    return new FormSubmission_Boolean().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Boolean | PlainMessage<FormSubmission_Boolean> | undefined, b: FormSubmission_Boolean | PlainMessage<FormSubmission_Boolean> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Boolean, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Checklist
 */
export class FormSubmission_Checklist extends Message<FormSubmission_Checklist> {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[] = [];

  constructor(data?: PartialMessage<FormSubmission_Checklist>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Checklist";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Checklist {
    return new FormSubmission_Checklist().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Checklist {
    return new FormSubmission_Checklist().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Checklist {
    return new FormSubmission_Checklist().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Checklist | PlainMessage<FormSubmission_Checklist> | undefined, b: FormSubmission_Checklist | PlainMessage<FormSubmission_Checklist> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Checklist, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Date
 */
export class FormSubmission_Date extends Message<FormSubmission_Date> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Date>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Date";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Date {
    return new FormSubmission_Date().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Date {
    return new FormSubmission_Date().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Date {
    return new FormSubmission_Date().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Date | PlainMessage<FormSubmission_Date> | undefined, b: FormSubmission_Date | PlainMessage<FormSubmission_Date> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Date, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.DateTime
 */
export class FormSubmission_DateTime extends Message<FormSubmission_DateTime> {
  /**
   * @generated from field: string date = 1;
   */
  date = "";

  /**
   * @generated from field: string time = 2;
   */
  time = "";

  constructor(data?: PartialMessage<FormSubmission_DateTime>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.DateTime";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_DateTime {
    return new FormSubmission_DateTime().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_DateTime {
    return new FormSubmission_DateTime().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_DateTime {
    return new FormSubmission_DateTime().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_DateTime | PlainMessage<FormSubmission_DateTime> | undefined, b: FormSubmission_DateTime | PlainMessage<FormSubmission_DateTime> | undefined): boolean {
    return proto3.util.equals(FormSubmission_DateTime, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Dosage
 */
export class FormSubmission_Dosage extends Message<FormSubmission_Dosage> {
  /**
   * @generated from field: qliq_protobuf.chat.FormSubmission.DosageUnit unit = 1;
   */
  unit = FormSubmission_DosageUnit.DOSAGE_UNIT_UNKNOWN;

  /**
   * @generated from field: google.protobuf.FloatValue value = 2;
   */
  value?: number;

  constructor(data?: PartialMessage<FormSubmission_Dosage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Dosage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(FormSubmission_DosageUnit) },
    { no: 2, name: "value", kind: "message", T: FloatValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Dosage {
    return new FormSubmission_Dosage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Dosage {
    return new FormSubmission_Dosage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Dosage {
    return new FormSubmission_Dosage().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Dosage | PlainMessage<FormSubmission_Dosage> | undefined, b: FormSubmission_Dosage | PlainMessage<FormSubmission_Dosage> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Dosage, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Dropdown
 */
export class FormSubmission_Dropdown extends Message<FormSubmission_Dropdown> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Dropdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Dropdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Dropdown {
    return new FormSubmission_Dropdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Dropdown {
    return new FormSubmission_Dropdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Dropdown {
    return new FormSubmission_Dropdown().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Dropdown | PlainMessage<FormSubmission_Dropdown> | undefined, b: FormSubmission_Dropdown | PlainMessage<FormSubmission_Dropdown> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Dropdown, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Email
 */
export class FormSubmission_Email extends Message<FormSubmission_Email> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Email>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Email";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Email {
    return new FormSubmission_Email().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Email {
    return new FormSubmission_Email().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Email {
    return new FormSubmission_Email().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Email | PlainMessage<FormSubmission_Email> | undefined, b: FormSubmission_Email | PlainMessage<FormSubmission_Email> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Email, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Frequency
 */
export class FormSubmission_Frequency extends Message<FormSubmission_Frequency> {
  /**
   * @generated from field: qliq_protobuf.chat.FormSubmission.TimeUnit per = 1;
   */
  per = FormSubmission_TimeUnit.TIME_UNIT_UNKNOWN;

  /**
   * @generated from field: google.protobuf.UInt32Value count = 2;
   */
  count?: number;

  constructor(data?: PartialMessage<FormSubmission_Frequency>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Frequency";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "per", kind: "enum", T: proto3.getEnumType(FormSubmission_TimeUnit) },
    { no: 2, name: "count", kind: "message", T: UInt32Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Frequency {
    return new FormSubmission_Frequency().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Frequency {
    return new FormSubmission_Frequency().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Frequency {
    return new FormSubmission_Frequency().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Frequency | PlainMessage<FormSubmission_Frequency> | undefined, b: FormSubmission_Frequency | PlainMessage<FormSubmission_Frequency> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Frequency, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Number
 */
export class FormSubmission_Number extends Message<FormSubmission_Number> {
  /**
   * @generated from field: google.protobuf.FloatValue value = 1;
   */
  value?: number;

  constructor(data?: PartialMessage<FormSubmission_Number>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Number";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "message", T: FloatValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Number {
    return new FormSubmission_Number().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Number {
    return new FormSubmission_Number().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Number {
    return new FormSubmission_Number().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Number | PlainMessage<FormSubmission_Number> | undefined, b: FormSubmission_Number | PlainMessage<FormSubmission_Number> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Number, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.PainScale
 */
export class FormSubmission_PainScale extends Message<FormSubmission_PainScale> {
  /**
   * @generated from field: google.protobuf.UInt32Value value = 1;
   */
  value?: number;

  constructor(data?: PartialMessage<FormSubmission_PainScale>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.PainScale";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "message", T: UInt32Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_PainScale {
    return new FormSubmission_PainScale().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_PainScale {
    return new FormSubmission_PainScale().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_PainScale {
    return new FormSubmission_PainScale().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_PainScale | PlainMessage<FormSubmission_PainScale> | undefined, b: FormSubmission_PainScale | PlainMessage<FormSubmission_PainScale> | undefined): boolean {
    return proto3.util.equals(FormSubmission_PainScale, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.PhoneNumber
 */
export class FormSubmission_PhoneNumber extends Message<FormSubmission_PhoneNumber> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_PhoneNumber>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.PhoneNumber";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_PhoneNumber {
    return new FormSubmission_PhoneNumber().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_PhoneNumber {
    return new FormSubmission_PhoneNumber().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_PhoneNumber {
    return new FormSubmission_PhoneNumber().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_PhoneNumber | PlainMessage<FormSubmission_PhoneNumber> | undefined, b: FormSubmission_PhoneNumber | PlainMessage<FormSubmission_PhoneNumber> | undefined): boolean {
    return proto3.util.equals(FormSubmission_PhoneNumber, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.RadioButton
 */
export class FormSubmission_RadioButton extends Message<FormSubmission_RadioButton> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_RadioButton>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.RadioButton";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_RadioButton {
    return new FormSubmission_RadioButton().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_RadioButton {
    return new FormSubmission_RadioButton().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_RadioButton {
    return new FormSubmission_RadioButton().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_RadioButton | PlainMessage<FormSubmission_RadioButton> | undefined, b: FormSubmission_RadioButton | PlainMessage<FormSubmission_RadioButton> | undefined): boolean {
    return proto3.util.equals(FormSubmission_RadioButton, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Rating
 */
export class FormSubmission_Rating extends Message<FormSubmission_Rating> {
  /**
   * @generated from field: google.protobuf.UInt32Value value = 1;
   */
  value?: number;

  constructor(data?: PartialMessage<FormSubmission_Rating>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Rating";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "message", T: UInt32Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Rating {
    return new FormSubmission_Rating().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Rating {
    return new FormSubmission_Rating().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Rating {
    return new FormSubmission_Rating().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Rating | PlainMessage<FormSubmission_Rating> | undefined, b: FormSubmission_Rating | PlainMessage<FormSubmission_Rating> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Rating, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Signature
 */
export class FormSubmission_Signature extends Message<FormSubmission_Signature> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Signature>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Signature";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Signature {
    return new FormSubmission_Signature().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Signature {
    return new FormSubmission_Signature().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Signature {
    return new FormSubmission_Signature().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Signature | PlainMessage<FormSubmission_Signature> | undefined, b: FormSubmission_Signature | PlainMessage<FormSubmission_Signature> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Signature, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Text
 */
export class FormSubmission_Text extends Message<FormSubmission_Text> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Text>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Text";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Text {
    return new FormSubmission_Text().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Text {
    return new FormSubmission_Text().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Text {
    return new FormSubmission_Text().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Text | PlainMessage<FormSubmission_Text> | undefined, b: FormSubmission_Text | PlainMessage<FormSubmission_Text> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Text, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Time
 */
export class FormSubmission_Time extends Message<FormSubmission_Time> {
  /**
   * @generated from field: string value = 1;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Time>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Time";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Time {
    return new FormSubmission_Time().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Time {
    return new FormSubmission_Time().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Time {
    return new FormSubmission_Time().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Time | PlainMessage<FormSubmission_Time> | undefined, b: FormSubmission_Time | PlainMessage<FormSubmission_Time> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Time, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.UploadedFiles
 */
export class FormSubmission_UploadedFiles extends Message<FormSubmission_UploadedFiles> {
  /**
   * @generated from field: repeated qliq_protobuf.chat.FormSubmission.UploadedFiles.Item items = 1;
   */
  items: FormSubmission_UploadedFiles_Item[] = [];

  constructor(data?: PartialMessage<FormSubmission_UploadedFiles>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.UploadedFiles";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: FormSubmission_UploadedFiles_Item, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_UploadedFiles {
    return new FormSubmission_UploadedFiles().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_UploadedFiles {
    return new FormSubmission_UploadedFiles().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_UploadedFiles {
    return new FormSubmission_UploadedFiles().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_UploadedFiles | PlainMessage<FormSubmission_UploadedFiles> | undefined, b: FormSubmission_UploadedFiles | PlainMessage<FormSubmission_UploadedFiles> | undefined): boolean {
    return proto3.util.equals(FormSubmission_UploadedFiles, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.UploadedFiles.Item
 */
export class FormSubmission_UploadedFiles_Item extends Message<FormSubmission_UploadedFiles_Item> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string filename = 2;
   */
  filename = "";

  /**
   * @generated from field: string content_type = 3;
   */
  contentType = "";

  constructor(data?: PartialMessage<FormSubmission_UploadedFiles_Item>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.UploadedFiles.Item";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_UploadedFiles_Item {
    return new FormSubmission_UploadedFiles_Item().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_UploadedFiles_Item {
    return new FormSubmission_UploadedFiles_Item().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_UploadedFiles_Item {
    return new FormSubmission_UploadedFiles_Item().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_UploadedFiles_Item | PlainMessage<FormSubmission_UploadedFiles_Item> | undefined, b: FormSubmission_UploadedFiles_Item | PlainMessage<FormSubmission_UploadedFiles_Item> | undefined): boolean {
    return proto3.util.equals(FormSubmission_UploadedFiles_Item, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Weight
 */
export class FormSubmission_Weight extends Message<FormSubmission_Weight> {
  /**
   * @generated from field: qliq_protobuf.chat.FormSubmission.WeightUnit unit = 1;
   */
  unit = FormSubmission_WeightUnit.WEIGNT_UNIT_UNKNOWN;

  /**
   * @generated from field: google.protobuf.FloatValue value = 2;
   */
  value?: number;

  constructor(data?: PartialMessage<FormSubmission_Weight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Weight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(FormSubmission_WeightUnit) },
    { no: 2, name: "value", kind: "message", T: FloatValue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Weight {
    return new FormSubmission_Weight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Weight {
    return new FormSubmission_Weight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Weight {
    return new FormSubmission_Weight().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Weight | PlainMessage<FormSubmission_Weight> | undefined, b: FormSubmission_Weight | PlainMessage<FormSubmission_Weight> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Weight, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Markdown
 */
export class FormSubmission_Markdown extends Message<FormSubmission_Markdown> {
  /**
   * @generated from field: repeated qliq_protobuf.chat.FormSubmission.Markdown.Item items = 1;
   */
  items: FormSubmission_Markdown_Item[] = [];

  constructor(data?: PartialMessage<FormSubmission_Markdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Markdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: FormSubmission_Markdown_Item, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Markdown {
    return new FormSubmission_Markdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Markdown {
    return new FormSubmission_Markdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Markdown {
    return new FormSubmission_Markdown().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Markdown | PlainMessage<FormSubmission_Markdown> | undefined, b: FormSubmission_Markdown | PlainMessage<FormSubmission_Markdown> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Markdown, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Markdown.Item
 */
export class FormSubmission_Markdown_Item extends Message<FormSubmission_Markdown_Item> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<FormSubmission_Markdown_Item>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Markdown.Item";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Markdown_Item {
    return new FormSubmission_Markdown_Item().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Markdown_Item {
    return new FormSubmission_Markdown_Item().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Markdown_Item {
    return new FormSubmission_Markdown_Item().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Markdown_Item | PlainMessage<FormSubmission_Markdown_Item> | undefined, b: FormSubmission_Markdown_Item | PlainMessage<FormSubmission_Markdown_Item> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Markdown_Item, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.SubmissionItem
 */
export class FormSubmission_SubmissionItem extends Message<FormSubmission_SubmissionItem> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from oneof qliq_protobuf.chat.FormSubmission.SubmissionItem.value
   */
  value: {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Address address = 2;
     */
    value: FormSubmission_Address;
    case: "address";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.BloodPressure blood_pressure = 3;
     */
    value: FormSubmission_BloodPressure;
    case: "bloodPressure";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Boolean boolean = 4;
     */
    value: FormSubmission_Boolean;
    case: "boolean";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Checklist checklist = 5;
     */
    value: FormSubmission_Checklist;
    case: "checklist";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Date date = 6;
     */
    value: FormSubmission_Date;
    case: "date";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.DateTime date_time = 7;
     */
    value: FormSubmission_DateTime;
    case: "dateTime";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Dosage dosage = 8;
     */
    value: FormSubmission_Dosage;
    case: "dosage";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Dropdown dropdown = 9;
     */
    value: FormSubmission_Dropdown;
    case: "dropdown";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Email email = 10;
     */
    value: FormSubmission_Email;
    case: "email";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Frequency frequency = 11;
     */
    value: FormSubmission_Frequency;
    case: "frequency";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Number number = 12;
     */
    value: FormSubmission_Number;
    case: "number";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.PainScale pain_scale = 13;
     */
    value: FormSubmission_PainScale;
    case: "painScale";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.PhoneNumber phone_number = 14;
     */
    value: FormSubmission_PhoneNumber;
    case: "phoneNumber";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.RadioButton radio_button = 15;
     */
    value: FormSubmission_RadioButton;
    case: "radioButton";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Rating rating = 16;
     */
    value: FormSubmission_Rating;
    case: "rating";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Signature signature = 17;
     */
    value: FormSubmission_Signature;
    case: "signature";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Text text = 18;
     */
    value: FormSubmission_Text;
    case: "text";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Time time = 19;
     */
    value: FormSubmission_Time;
    case: "time";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.UploadedFiles uploaded_files = 20;
     */
    value: FormSubmission_UploadedFiles;
    case: "uploadedFiles";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Weight weight = 21;
     */
    value: FormSubmission_Weight;
    case: "weight";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Markdown markdown = 22;
     */
    value: FormSubmission_Markdown;
    case: "markdown";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.FormSubmission.Submission subform = 23;
     */
    value: FormSubmission_Submission;
    case: "subform";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<FormSubmission_SubmissionItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.SubmissionItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address", kind: "message", T: FormSubmission_Address, oneof: "value" },
    { no: 3, name: "blood_pressure", kind: "message", T: FormSubmission_BloodPressure, oneof: "value" },
    { no: 4, name: "boolean", kind: "message", T: FormSubmission_Boolean, oneof: "value" },
    { no: 5, name: "checklist", kind: "message", T: FormSubmission_Checklist, oneof: "value" },
    { no: 6, name: "date", kind: "message", T: FormSubmission_Date, oneof: "value" },
    { no: 7, name: "date_time", kind: "message", T: FormSubmission_DateTime, oneof: "value" },
    { no: 8, name: "dosage", kind: "message", T: FormSubmission_Dosage, oneof: "value" },
    { no: 9, name: "dropdown", kind: "message", T: FormSubmission_Dropdown, oneof: "value" },
    { no: 10, name: "email", kind: "message", T: FormSubmission_Email, oneof: "value" },
    { no: 11, name: "frequency", kind: "message", T: FormSubmission_Frequency, oneof: "value" },
    { no: 12, name: "number", kind: "message", T: FormSubmission_Number, oneof: "value" },
    { no: 13, name: "pain_scale", kind: "message", T: FormSubmission_PainScale, oneof: "value" },
    { no: 14, name: "phone_number", kind: "message", T: FormSubmission_PhoneNumber, oneof: "value" },
    { no: 15, name: "radio_button", kind: "message", T: FormSubmission_RadioButton, oneof: "value" },
    { no: 16, name: "rating", kind: "message", T: FormSubmission_Rating, oneof: "value" },
    { no: 17, name: "signature", kind: "message", T: FormSubmission_Signature, oneof: "value" },
    { no: 18, name: "text", kind: "message", T: FormSubmission_Text, oneof: "value" },
    { no: 19, name: "time", kind: "message", T: FormSubmission_Time, oneof: "value" },
    { no: 20, name: "uploaded_files", kind: "message", T: FormSubmission_UploadedFiles, oneof: "value" },
    { no: 21, name: "weight", kind: "message", T: FormSubmission_Weight, oneof: "value" },
    { no: 22, name: "markdown", kind: "message", T: FormSubmission_Markdown, oneof: "value" },
    { no: 23, name: "subform", kind: "message", T: FormSubmission_Submission, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_SubmissionItem {
    return new FormSubmission_SubmissionItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_SubmissionItem {
    return new FormSubmission_SubmissionItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_SubmissionItem {
    return new FormSubmission_SubmissionItem().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_SubmissionItem | PlainMessage<FormSubmission_SubmissionItem> | undefined, b: FormSubmission_SubmissionItem | PlainMessage<FormSubmission_SubmissionItem> | undefined): boolean {
    return proto3.util.equals(FormSubmission_SubmissionItem, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.FormSubmission.Submission
 */
export class FormSubmission_Submission extends Message<FormSubmission_Submission> {
  /**
   * @generated from field: repeated qliq_protobuf.chat.FormSubmission.SubmissionItem items = 1;
   */
  items: FormSubmission_SubmissionItem[] = [];

  constructor(data?: PartialMessage<FormSubmission_Submission>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.FormSubmission.Submission";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: FormSubmission_SubmissionItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FormSubmission_Submission {
    return new FormSubmission_Submission().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FormSubmission_Submission {
    return new FormSubmission_Submission().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FormSubmission_Submission {
    return new FormSubmission_Submission().fromJsonString(jsonString, options);
  }

  static equals(a: FormSubmission_Submission | PlainMessage<FormSubmission_Submission> | undefined, b: FormSubmission_Submission | PlainMessage<FormSubmission_Submission> | undefined): boolean {
    return proto3.util.equals(FormSubmission_Submission, a, b);
  }
}

